import { useState, useEffect, useCallback } from "react";

interface NavItem {
  label: string;
  href: string;
}

const navItems: NavItem[] = [
  { label: "首页", href: "#hero" },
  { label: "关于我们", href: "#about" },
  { label: "平台优势", href: "#features" },
  { label: "观众热评", href: "#comments" },
  { label: "焦点专题", href: "#carousel" },
  { label: "常见问答", href: "#faq" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 20);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-100/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <a
            href="#hero"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick("#hero");
            }}
            className="flex items-center gap-2 cursor-pointer"
          >
            <span className="w-8 h-8 flex items-center justify-center">
              <i className="ri-movie-2-line text-primary-500 text-2xl"></i>
            </span>
            <span className="text-foreground-50 font-heading text-lg md:text-xl whitespace-nowrap">
              天美麻花星空
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.href);
                }}
                className="px-3 py-2 text-sm text-foreground-300 hover:text-primary-500 transition-colors rounded-md whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-foreground-200"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <nav className="md:hidden pb-4 flex flex-col gap-1 bg-background-100/95 backdrop-blur-md rounded-b-lg">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.href);
                }}
                className="px-4 py-3 text-sm text-foreground-300 hover:text-primary-500 hover:bg-background-200 transition-colors rounded-md whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
}